import usePlayer from '../../contexts/usePlayer';
import PlayButton from '../PlayButton';
import SpeedDrawer from '../SpeedDrawer';
import ControlButton from '../ControlButton';
import FastForwardIcon from '../icons/FastForwardIcon';
import SkipNextIcon from '../icons/SkipNextIcon';
import type { ListData } from '../../../../types';

interface ItemPlayBarProps {
  item: ListData;
  // Playlist support - when provided, pressing play on a non-playing item
  // will use playPlaylist instead of play
  playlist?: ListData;
}

export default function ItemPlayBar({ item, playlist }: ItemPlayBarProps) {
  const {
    nowPlaying,
    nowPlayingId,
    isLoading,
    playbackRate,
    setPlaybackRate,
    seekBackward,
    seekForward,
    nextTrack,
  } = usePlayer();

  const isNowPlaying = item.id === nowPlayingId;

  const bottomPadding = 16;

  const displayItem = isNowPlaying && nowPlaying ? nowPlaying : item;

  return (
    <div
      style={{
        width: '100%',
        maxWidth: 600,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        alignItems: 'center',
        justifyItems: 'center',
        paddingBottom: `${bottomPadding}px`,
        background: 'var(--background)',
      }}
    >
      {isNowPlaying ? (
        <>
          <SpeedDrawer
            playbackRate={playbackRate || 1}
            setPlaybackRate={setPlaybackRate}
            variant="inline"
          />
          <ControlButton
            onClick={() => seekBackward(5)}
            disabled={isLoading}
            title="Back 5s"
          >
            <span style={{ transform: 'rotate(180deg)', display: 'flex' }}>
              <FastForwardIcon color="var(--gold)" size={48} />
            </span>
          </ControlButton>
          <PlayButton size={62} item={displayItem} />
          <ControlButton
            onClick={() => seekForward(5)}
            disabled={isLoading}
            title="Forward 5s"
          >
            <FastForwardIcon color="var(--gold)" size={48} />
          </ControlButton>
          <ControlButton
            onClick={() => nextTrack()}
            disabled={isLoading}
            title="Next in queue"
          >
            <SkipNextIcon color="var(--gold)" size={48} />
          </ControlButton>
        </>
      ) : (
        <div style={{ gridColumn: 3 }}>
          {/* For playlists, pass the playlist so playPlaylist is called */}
          <PlayButton size={62} item={playlist || displayItem} />
        </div>
      )}
    </div>
  );
}
